import parsePhoneNumberFromString from 'libphonenumber-js';
import * as yup from 'yup';
import i18n from 'Utilities/i18n';
const yupSchema = () => {
  return yup.object().shape({
    otp: yup.string().required(i18n.t('VerifyMobileNumber.microcopy.errors.invalidCode')).min(6, i18n.t('VerifyMobileNumber.microcopy.errors.invalidCode')),
    mobileNumber: yup.string().required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).min(7, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).test('test-valid-phone', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'), value => parsePhoneNumberFromString(value ?? '', {
      extract: false
    })?.isValid() ?? false)
  });
};
export default yupSchema;